import { useState } from "react";
import { motion } from "framer-motion";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";
import { CA, X_URL, copyText, scrollToId } from "@/data";
import { CoinMark } from "@/components/Navbar";
import GiantTate from "@/components/GiantTate";

const EASE = [0.22, 1, 0.36, 1];

export default function Footer() {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await copyText(CA, "Contract address copied");
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <footer className="relative overflow-hidden border-t border-[rgba(229,169,60,0.18)]" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 pb-10 pt-20 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: EASE }}
          className="flex flex-col items-center gap-8"
        >
          <button
            onClick={handleCopy}
            data-testid="footer-copy-ca-button"
            className="group flex max-w-full items-center gap-3 rounded-full border border-dashed border-[rgba(229,169,60,0.4)] bg-[#0E1015] px-6 py-3.5 transition-colors duration-300 hover:border-[#F6C85F]"
          >
            <span className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-[#64748B]">CA</span>
            <span className="truncate font-mono2 text-xs text-[#94A3B8] transition-colors group-hover:text-[#F6C85F] sm:text-sm">
              {CA}
            </span>
            {copied ? (
              <Check className="h-4 w-4 shrink-0 text-[#F6C85F]" />
            ) : (
              <Copy className="h-4 w-4 shrink-0 text-[#64748B] group-hover:text-[#F6C85F]" />
            )}
          </button>

          <div className="flex flex-wrap items-center justify-center gap-4">
            <a
              href={X_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-x-button"
              className="flex items-center gap-2.5 rounded-full bg-[#E5A93C] px-7 py-3.5 font-display text-base font-bold text-[#07080A] transition-all duration-300 hover:bg-[#F6C85F] hover:shadow-[0_0_36px_rgba(246,200,95,0.4)]"
            >
              <svg viewBox="0 0 24 24" className="h-4 w-4 fill-current" aria-hidden="true">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
              Join on X
            </a>
            <button
              onClick={() => toast.success("🐈 MEOW. The cat acknowledges your service. 🇺🇸")}
              data-testid="footer-meow-button"
              className="rounded-full border border-[rgba(229,169,60,0.4)] px-7 py-3.5 font-display text-base font-bold text-[#F8FAFC] transition-all duration-300 hover:border-[#F6C85F] hover:bg-[#0E1015]"
            >
              Meow Button
            </button>
            <button
              onClick={() => scrollToId("#top")}
              data-testid="footer-top-button"
              className="rounded-full border border-[rgba(229,169,60,0.4)] px-7 py-3.5 font-display text-base font-bold text-[#F8FAFC] transition-all duration-300 hover:border-[#F6C85F] hover:bg-[#0E1015]"
            >
              Back to Top
            </button>
          </div>
        </motion.div>

        {/* Giant display */}
        <GiantTate />

        <div className="mt-10 flex flex-col items-center justify-between gap-5 border-t border-[rgba(229,169,60,0.12)] pt-8 sm:flex-row">
          <div className="flex items-center gap-2.5">
            <CoinMark className="h-7 w-7" />
            <span className="font-display text-sm font-bold text-[#94A3B8]">
              $TATE — Make Memes Great Again
            </span>
          </div>
          <p className="max-w-xl text-center font-mono2 text-[10px] leading-relaxed tracking-wide text-[#64748B] sm:text-right">
            $TATE is a memecoin created for entertainment and community. Nothing here is
            financial advice. Not affiliated with Donald J. Trump or the $CATE project.
            © 2026 The Meme Movement.
          </p>
        </div>
      </div>
    </footer>
  );
}
